import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import TransformComponent from '../../../Component/Transform';

export class RayRotate extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: { rotationSpeed: number }
    ): IterableIterator<number> {
        const transform = gameObject.getComponent(TransformComponent);

        const rotationSpeed = meta.rotationSpeed || 0.5;

        while (true) {
            transform.rotation += rotationSpeed;
            yield;
        }
    }
}
